export const SET_MY_STORE = 'SET_MY_STORE';
export const GET_MY_STORE = 'GET_MY_STORE';
